export default function PoolServices() {
  const services = [
    {
      icon: 'ri-water-flash-line',
      title: 'Custom Pool Design',
      description: 'Personalized pool design services tailored to your backyard space, lifestyle, and budget with 3D renderings'
    },
    {
      icon: 'ri-hammer-line',
      title: 'Pool Construction',
      description: 'Expert gunite, fiberglass, and vinyl liner pool construction with quality materials built to last in El Paso\'s climate'
    },
    {
      icon: 'ri-paint-brush-line',
      title: 'Pool Renovation',
      description: 'Complete pool remodeling including resurfacing, tile replacement, coping upgrades, and equipment modernization'
    },
    {
      icon: 'ri-drop-line',
      title: 'Pool Equipment',
      description: 'Installation and upgrade of pumps, filters, heaters, automation systems, and energy-efficient equipment'
    },
    {
      icon: 'ri-landscape-line',
      title: 'Outdoor Living',
      description: 'Complete backyard transformations with patios, outdoor kitchens, fire features, and landscaping'
    },
    {
      icon: 'ri-tools-fill',
      title: 'Pool Maintenance',
      description: 'Regular maintenance services, repairs, and seasonal opening/closing to keep your pool in perfect condition'
    }
  ];

  return (
    <section id="services" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Complete Pool Services
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            From initial design to ongoing maintenance, our El Paso pool contractors provide comprehensive services for your backyard paradise
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-gray-50 to-white p-8 rounded-xl border border-gray-200 hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-16 h-16 bg-teal-600 rounded-lg flex items-center justify-center mb-6">
                <i className={`${service.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">
                {service.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
